import { authHeader, accountHeader, BASE_URL, handleResponse, handleResponseBlob } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const inboxService = {
    getHistory,
    sendMessage,
    sendNote,
    sendEmailMessage,
    resendMessage,
    downloadMessageImage,
    uploadFile,
    sendTypingStatus,
    sendWhatsAppTemplate,
    getOriginalHtml,
};

function getHistory(conversationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}/messages`, requestOptions).then(handleResponse);
}

function sendMessage(conversationId, message) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ conversationId, message }),
    };
    return fetch(`${BASE_URL}api/inbox/messages`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.InboxMessageSent, { format: 'message' }));
}

function sendNote(conversationId, content) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ content }),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}/notes`, requestOptions).then(handleResponse);
}

function sendEmailMessage(conversationId, htmlContent, subject, cc, bcc) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ conversationId, htmlContent, subject, cc, bcc }),
    };
    return fetch(`${BASE_URL}api/inbox/messages/email`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.InboxMessageSent, { format: 'email' }));
}

function resendMessage(messageId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/messages/${messageId}:resend`, requestOptions).then(handleResponse);
}

function downloadMessageImage(url) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/assets/download-message-image?url=${url}`, requestOptions).then(handleResponseBlob);
}

function uploadFile(data) {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestOptions = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + user.token,
            ...accountHeader(),
        },
        body: data,
    };
    return fetch(`${BASE_URL}api/inbox/messages/attachments`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.InboxMessageSent, { format: 'attachment' }));
}

function sendTypingStatus(conversationId, isTyping) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}:typing?typing=${isTyping}`, requestOptions).then(
        handleResponse,
    );
}

function sendWhatsAppTemplate(conversationId, templateId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(
        `${BASE_URL}api/inbox/conversations/${conversationId}:open-window?whatsAppTemplateId=${templateId}`,
        requestOptions,
    )
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.InboxMessageSent, { format: 'whatsapp_template' }));
}

function getOriginalHtml(messageId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/messages/${messageId}/original-html`, requestOptions).then(handleResponse);
}
